// Sons de la table de marque (Web Audio, aucun fichier) : bip 10 dernières secondes, klaxon de fin, clic sur point.
let ctx;
const ac = () => { try { ctx = ctx || new (window.AudioContext || window.webkitAudioContext)(); if (ctx.state === "suspended") ctx.resume(); return ctx; } catch { return null; } };
const tone = (freq, ms, type = "square", gain = 0.25) => { const c = ac(); if (!c) return; const o = c.createOscillator(); const g = c.createGain(); o.type = type; o.frequency.value = freq; g.gain.value = gain; o.connect(g); g.connect(c.destination); o.start(); g.gain.exponentialRampToValueAtTime(0.001, c.currentTime + ms / 1000); o.stop(c.currentTime + ms / 1000); };
export const sounds = {
  unlock: () => ac(),
  beep: () => tone(1200, 120),
  horn: () => { tone(220, 900, "sawtooth", 0.4); setTimeout(() => tone(220, 900, "sawtooth", 0.4), 950); },
  point: () => tone(660, 80, "sine", 0.2),
  penalty: () => tone(180, 200, "triangle", 0.3),
  bell: () => { tone(880, 400, "sine", 0.3); setTimeout(() => tone(880, 400, "sine", 0.3), 450); },
};

// Hook : déclenche bips (10 → 1 s) et klaxon (0 s / fin) à partir du chrono affiché
export function useTimerSounds(remaining, running, status) {
  const key = `${remaining}|${running}|${status}`;
  if (typeof window === "undefined") return;
  if (window.__jmLastSoundKey === key) return;
  const prev = window.__jmLastRemaining;
  window.__jmLastSoundKey = key; window.__jmLastRemaining = remaining;
  if (running && remaining <= 10 && remaining > 0 && prev !== remaining) sounds.beep();
  if (prev > 0 && remaining === 0) sounds.horn();
  if (status === "finished" && window.__jmLastStatus !== "finished") sounds.horn();
  window.__jmLastStatus = status;
}
